import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
  backHome?: boolean;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  desc,
  actionLabel,
  onAction,
  backHome,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-3xl text-foreground-400">
        <i className={icon} />
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">{title}</h3>
      {desc && <p className="mt-1.5 max-w-md text-sm text-foreground-500">{desc}</p>}
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {actionLabel && onAction && (
          <button
            type="button"
            onClick={onAction}
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            {actionLabel}
          </button>
        )}
        {backHome && (
          <Link
            to="/"
            className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            返回首页
          </Link>
        )}
      </div>
    </div>
  );
}